<template>
  <base-stat-item :metric="metric" label="Impressions">
    <template v-slot:icon>
      <impressions-icon></impressions-icon>
    </template>
  </base-stat-item>
</template>
<script>
import ImpressionsIcon from '../Icons/ImpressionsIcon.vue';
import BaseStatItem from './BaseStatItem.vue';

export default {
  props: {
    metric: [String, Number]
  },
  components: {
    ImpressionsIcon,
    BaseStatItem,
  },
};
</script>
